import { useCallback, useEffect, useState } from "react";
import { fetchDataReports, type DataReportsPayload } from "../../../api/dataReports";
import { getUserFacingMessage } from "../../../api/errors";

export type ReportsDateRange = "7d" | "30d" | "90d" | "custom";

function monthsForRange(r: ReportsDateRange): number {
  if (r === "7d") return 2;
  if (r === "30d") return 3;
  if (r === "90d") return 6;
  return 6;
}

export function useDataReportsPayload(tenantLegacyId: string, dateRange: ReportsDateRange) {
  const [payload, setPayload] = useState<DataReportsPayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const months = monthsForRange(dateRange);

  const reload = useCallback(() => {
    setLoading(true);
    setError(null);
    void fetchDataReports(tenantLegacyId, months)
      .then((d) => {
        setPayload(d);
      })
      .catch((e) => {
        setError(getUserFacingMessage(e, "报表数据暂不可用，请稍后重试。"));
        setPayload(null);
      })
      .finally(() => setLoading(false));
  }, [tenantLegacyId, months]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { payload, loading, error, reload };
}
